"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEAddressCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

var _FAEText = require("../FAEText/FAEText");

var _FAELoading = require("../FAELoading/FAELoading");

require("./FAEAddressCard.scss");

const _excluded = ["label", "border", "className", "additionalPrice", "chargeAdditionalPrice", "currencySymbol", "address", "postalCode", "distance", "loading", "loaderProps", "shadowBoxProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEAddressCard = _ref => {
  let {
    label,
    border,
    className = "",
    additionalPrice,
    chargeAdditionalPrice = false,
    currencySymbol,
    address,
    postalCode = "",
    distance = "",
    loading,
    loaderProps,
    shadowBoxProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, shadowBoxProps, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--address-card-main-container ".concat(className)
  }, rest), chargeAdditionalPrice && /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--address-card-price-added-tab"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    className: "fae--address-card-price-tab-text",
    paragraph: true,
    primary: true
  }, "+ ", currencySymbol, additionalPrice)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--address-card-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--address-card-content"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    paragraph: true,
    tertiary: true
  }, address), postalCode !== "" && /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, postalCode)), distance !== "" && /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--address-card-distance-from-user"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    secondary: true
  }, distance), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    paragraph: true
  }, "Miles Away")))));
};

exports.FAEAddressCard = FAEAddressCard;